<molec-auth-header [title]="title" [description]="description"> </molec-auth-header>
<div class="hidden md:block">
  <forgot-actions [title]="'Đóng'" [active]="true" (submitEvent)="submitEvent.emit($event)"></forgot-actions>
</div>
<div class="block md:hidden">
  <forgot-actions [title]="'Đóng'" [active]="true" (submitEvent)="openFormLoginMobile($event)"></forgot-actions>
</div>
<option-link [suggestText]="'Bạn chưa nhận được Email? Chờ 1 phút sau đó bấm gửi lại nha!!!'" [title]="'Gửi lại'" (btnClicked)="resend.emit()"></option-link>
<p class="text-center text-sm text-gray-500 mt-2">
  Vẫn không nhận được (nhớ xem cả thư mục Spam)? Nhắn
  <a href="https://www.messenger.com/t/105509188159417" target="_blank" rel="noopener noreferrer" class="text-blue-600 hover:underline">Fanpage Awread</a>
  để được hỗ trợ.
</p>
<div [hidden]="hiddenLoginSuggest">
  <div class="hidden md:block">
    <option-link [suggestText]="'Bạn đã nhớ thông tin đăng nhập?'" [title]="'Đăng nhập'" [link]="'/login'"></option-link>
  </div>
  <div class="block md:hidden">
    <option-link (click)="openFormLoginMobile($event)" [suggestText]="'Bạn đã nhớ thông tin đăng nhập?'" [title]="'Đăng nhập'" [link]="null"></option-link>
  </div>
</div>
